<template>
    <div class="list">
		<div class="item" v-for="(item,i) in list" :key="i">
			<router-link :to="`/exhibit-detail-${item.id}`" target="_blank">
				<!-- <span>{{i+1}}</span> -->
				<p>{{item.title}}</p>
			</router-link>
		</div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex"
	import {
		newsList,
		newsCat
	} from "@/api/cms/news";
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	
    export default {
        name: "list3",
        components: {
			SubTitle,
			DescText
        },
        props: {
            config: {
                type: Object,
                // required: true
            },
			list: {
                type: Array,
                required: true
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
.list{
	.item{
		display: block;
		// overflow: hidden;
		a{
			display: flex;
			overflow: hidden;
			// span{
			// 	// float: left;
			// 	width: 35px;
			// 	color: #686868;
			// 	font-size: 20px;
			// 	line-height: 30px;
			// 	text-align: center;
			// }
			p::before{
				content: '·';
				display: block;
				margin: 0 15px 0 0 ;
				font-size: 20px;
				// height: 30px;
				float: left;
				line-height: 30px;
			}
			p{
				flex: 1;
				line-height: 30px;
				height: 30px;
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
			}
		}
	}
}
</style>
